module.exports = __webpack_public_path__ + "img/techIot_EN.jpg";